// extracted by mini-css-extract-plugin
export var cardHeader = "_rz-0";
export var reorderHandle = "_rz-3";
export var titleArea = "_rz-1";
export var titleAreaWithHandle = "_rz-2";